(() => {
/**
 * @file
 * Show hidden rows
 *
 */ ((Drupal1, $)=>{
    Drupal1.behaviors.displaAllFacts = {
        attach: (context, settings)=>{
            $(context.getElementsByClassName("display-all product-facts")).once("display-all-product-facts").on("click", function(e) {
                e.preventDefault();
                $(this).toggleClass("open");
                $(this.previousElementSibling.getElementsByClassName("hidden")).toggle();
            });
        }
    };
})(Drupal, jQuery);

})();
//# sourceMappingURL=display-facts.js.map
